<template>
  <div>
    <b-modal
        :title="title"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        size="xl"
        no-close-on-backdrop lazy>
      <div class="row">
        <div class="col-md-6 col-lg-3">
          <b-form-group>
            <b-input-group class="input-group-trans">
              <b-form-input v-model="formSearchData.keyword" :placeholder="$t('Keyword')"/>
              <b-input-group-append>
                <b-input-group-text>
                  <img src="images/ico-search.png"/>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-md-6 col-lg-3">
          <b-form-group>
            <b-select v-model="formSearchData.id" class="input-trans calendar">
              <option v-for="(schedule, index) in schedules" :key="index" :value="schedule.ScheduleID">
                {{ schedule.Name }}
              </option>
            </b-select>
          </b-form-group>
        </div>
        <div class="col-md-6 col-lg-3">
          <b-form-group>
            <b-select v-model="formSearchData.isGuest" class="input-trans users">
              <option value="false">{{$t("Only participants")}}</option>
              <option value="true">{{$t("All")}}</option>
            </b-select>
          </b-form-group>
        </div>
        <div class="col-md-6 col-lg-3">
          <b-form-group>
            <b-button @click="search" pill size="lg" class="btn-block btn-trans-primary">{{
                $t("Search now")
              }}
            </b-button>
          </b-form-group>
        </div>
      </div>
      <div class="mb-2">
        <button class="btn-trans-small mr-1 mb1" @click="addParticipants"><img src="images/ico-plus-circle-solid-16.png"/>
          {{ $t("Add new") }}
        </button>
        <button class="btn-trans-small mr-1 mb1" @click="report"><img src="images/ico-download-solid-16.png"/>
          {{ $t("Report") }}
        </button>
      </div>
      <vue-custom-scrollbar class="list-participants row">
        <div class="col-md-12 col-lg-6 col-xl-4" v-for="(participant, index) in participants" :key="index">
          <b-card class="participant-item">
            <div class="d-flex">
              <div class="participant-avatar">
                <div class="avatar hide-hover">
                  <b-icon icon="person-fill"></b-icon>
                </div>
                <div class="btn-delete" @click="deleteParticipant(participant)">
                  <b-icon icon="trash"></b-icon>
                </div>
                <button @click="changeStatus(participant)" :class="participant.IsBlocked ? 'status' : 'status active'"
                        v-b-tooltip.hover :title="$t(participant.IsBlocked ? 'Deactivate' : 'Activate')">
                  <b-icon :icon="participant.IsBlocked ? 'lock-fill': 'unlock-fill'"></b-icon>
                </button>
              </div>
              <div class="participant-info">
                <div class="id d-flex justify-content-between">
                  <div>{{ participant.Fullname }}</div>
                  <strong class="trans-id">ID: {{ participant.TransID }}</strong></div>
                <div class="email">
                  <b-icon icon="envelope-fill"></b-icon>
                  <a :href="'mailto:' + participant.Email">{{ participant.Email }}</a></div>
                <div class="phone">
                  <b-icon icon="telephone-fill"></b-icon>
                  <a :href="'tel:' + participant.PhoneNumber">{{ participant.PhoneNumber }}</a></div>
              </div>
            </div>
          </b-card>
        </div>
      </vue-custom-scrollbar>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
    <ReportParticipantsModal ref="reportParticipantsModal"/>
    <AddParticipantsModal ref="addParticipantsModal" @added="search"/>
  </div>
</template>

<script>
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";
import ReportParticipantsModal from "./ReportParticipantsModal";
import AddParticipantsModal from "./AddParticipantsModal";

export default {
  name: "ParticipantsModal",
  components: {ReportParticipantsModal, AddParticipantsModal},
  data: function () {
    return {
      loading: false,
      show: false,
      title: "",
      searchData: {
        id: null,
        keyword: "",
        isGuest: false
      },
      formSearchData: {
        id: null,
        keyword: "",
        isGuest: false
      },
      schedules: [],
      participants: []
    }
  },
  created() {
    let buttons = this.$store.getters.mainButtons;
    let keys = Object.keys(buttons);
    this.title = keys.includes("Participants") ? buttons["Participants"] : this.$t("Participants");
  },
  methods: {
    async open() {
      this.loading = true;
      let response = await meetingService.initMeetingParticipants();
      this.loading = false;
      if (!response)
        return;

      this.schedules = response.Schedules;
      if (this.schedules.length > 0)
        this.formSearchData.id = this.schedules[0].ScheduleID;

      this.searchData.id = this.formSearchData.id;
      this.participants = response.Participants
      this.show = true;
    },
    async changeStatus(participant) {
      this.loading = true;
      let response = await meetingService.blockMeetingParticipant({
        id: participant.ParticipantID,
        isBlocked: !participant.IsBlocked
      })

      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      participant.IsBlocked = !participant.IsBlocked;
      let data = JSON.parse(response.substr(3));
      dialogHelper.alert(data.Msg, "success");
    },
    search() {
      this.formData = this.formSearchData;
      this.load();
    },
    async load() {
      this.loading = true;
      let response = await meetingService.meetingParticipants(this.formData);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      this.participants = JSON.parse(response.substr(3));
    },
    async deleteParticipant(participant) {
      let result = await dialogHelper.confirm("Are you sure to delete this participant?")
      if (!result)
        return;

      this.loading = true;
      let response = await meetingService.deleteMeetingParticipant({
        id: participant.ParticipantID,
        isGuest: this.formData.isGuest,
        idSchedule: this.formData.id,
        keyword: this.formData.keyword,
      });

      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      let data = JSON.parse(response.substr(3));
      dialogHelper.alert(data.Msg, "success");
      this.participants = data.Participants;
    },
    report() {
      this.$refs.reportParticipantsModal.open(this.searchData.id, this.searchData.isGuest);
    },
    addParticipants() {
      this.$refs.addParticipantsModal.open(this.searchData.id);
    }
  }
}
</script>

<style scoped>

</style>